export enum StatePoint {
  success = 'success',
  warning = 'warning',
  danger = 'danger'
}
